import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { Workprocess } from './workprocess';
import { catchError } from 'rxjs/operators';
import { HttpError } from '../../errors';
import { WorkprocessTemp } from './workprocessTemp';
import { AssessmentCriteria } from './assessment-criteria';

@Injectable()
export class WorkprocessService {

    private workprocessError = new Subject<boolean>();
    public workprocessError$ = this.workprocessError.asObservable();

    constructor(private http: HttpClient) { }

    public getWorkProcessByCreboIdAndWorkprocessCode(creboId: string, workProcessCode: string): any {
        return this.http.get<WorkprocessTemp>(`/kerntaken/${creboId}/werkproces/${workProcessCode}`)
            .map(data => {
                const items = new Array<AssessmentCriteria>();
                data.beoordelingsvorm.forEach((beoordelingsvorm) => {
                    beoordelingsvorm.beoordelingscriteria.forEach((criteria, index) => {
                        const newCriteria = criteria;
                        if (index === 0) {
                            newCriteria.beoordelingsvorm = beoordelingsvorm.label;
                        }
                        items.push(newCriteria);
                    });
                });
                const workprocess = new Workprocess();
                workprocess.id = data.id;
                workprocess.naam = data.naam;
                workprocess.cijfer = data.cijfer;
                workprocess.code = data.code;
                workprocess.creboId = data.creboId;
                workprocess.geldigTot = data.geldigTot;
                workprocess.geldigVanaf = data.geldigVanaf;
                workprocess.omschrijving = data.omschrijving;
                workprocess.resultaatWerkproces = data.resultaatWerkproces;
                workprocess.beoordelingsvorm = items;
                workprocess.opmerkingen = data.opmerkingen;
                workprocess.mogelijkeResultaten = data.mogelijkeResultaten;
                return workprocess;
            })
            .pipe(catchError(error => {
                this.workprocessError.next(false);
                throw new HttpError(`Error fetching the workprocess for the workprocess: ${workProcessCode} & creboId: ${creboId}`);
            })
        );
    }

    public postExplanation(creboId, workprocessCode, toelichting) {
        return this.http.post<string>(`/kerntaken/${creboId}/werkproces/${workprocessCode}/toelichting`, {
            omschrijving: toelichting
        })
        .pipe(catchError(error => {
            this.workprocessError.next(false);
            throw new HttpError(`Error posting the explanation for the workprocess: ${workprocessCode} & creboId: ${creboId}`)
        }));
    }

}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/workprocess.service.ts